// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import HomePage from './pages/HomePage';
import GamePage from './pages/GamePage';
import ArchivePage from './pages/ArchivePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/archive" element={<ArchivePage />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
